import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  CreditCard, GooglePay, PaymentForm
} from 'react-square-web-payments-sdk';

import { APIClient } from '../../client';
import { LifeDocumentIntroHeader } from '../../pages';

export default function SignupPaymentScreen() {
  const navigate = useNavigate();
  
  const cardTokenizeResponseReceived = useCallback(async (token, verifiedBuyer) => {
    console.log(token, verifiedBuyer);

    const client = new APIClient('api/payments');
    const response = await client.create({
      token: token.token,
      verifiedBuyer: verifiedBuyer,
      plan: 'monthly'
    });

    console.log('PAYMENT CREATION RESPONSE', response);
    // navigate('/signup/complete');
  }, [ navigate ]);

  const createPaymentRequest = useCallback(() => ({
    countryCode: 'US',
    currencyCode: 'USD',
    total: {
      amount: '1.00',
      label: 'Total',
    },
  }), [ ]);

  return (
    <PaymentForm
      applicationId="sandbox-sq0idb-AAdrAzE_enM8a9Ng-dM-8Q"
      cardTokenizeResponseReceived={cardTokenizeResponseReceived}
      locationId="LBX2JX5P51W8E"
      createPaymentRequest={createPaymentRequest}
    >
      <LifeDocumentIntroHeader
        icon="credit_card"
        title="Payment"
        description="Enter your payment information."
      />
      <br />
      <GooglePay />
      <CreditCard />
    </PaymentForm>
  );
}